const SET_ALERT = "SET_ALERT";
const UNSET_ALERT = "UNSET_ALERT";

const initialState = {
  loading: false,
  alert: {}
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case SET_ALERT:
      return {
        ...state,
        alert: {
          msg: action.msg,
          kind: action.kind
        }
      };
    case UNSET_ALERT:
      return {
        ...state,
        alert: {}
      };

    default:
      return state;
  }
}

export function unsetAlert() {
  return { type: UNSET_ALERT };
}

export function setAlert(msg, kind = "success") {
  return {
    type: SET_ALERT,
    msg,
    kind
  };
}
